// extracted by mini-css-extract-plugin
module.exports = {"signInLink":"manage-device_signInLink__1T_AO"};